/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LanguageInputs */

const en_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const es_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const de_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const zh_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ar_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللغة`)
};

const fr_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const vi_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngôn ngữ`)
};

const sw_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lugha`)
};

const th_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาษา`)
};

const bs_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jezik`)
};

const ja_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const ko_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언어`)
};

const pt_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const it_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

const sv_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Språk`)
};

const nl_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taal`)
};

const da_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprog`)
};

const nb_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Språk`)
};

const fi_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kieli`)
};

const pl_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Język`)
};

const ru_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const tr_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil`)
};

const hi_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा`)
};

const id_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa`)
};

const ms_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa`)
};

const cs_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jazyk`)
};

const el_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γλώσσα`)
};

const he_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שפה`)
};

const af_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taal`)
};

const hu_nav_language = /** @type {(inputs: Nav_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyelv`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Nav_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language = /** @type {((inputs?: Nav_LanguageInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LanguageInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language(inputs)
	if (locale === "de") return de_nav_language(inputs)
	if (locale === "zh") return zh_nav_language(inputs)
	if (locale === "ar") return ar_nav_language(inputs)
	if (locale === "fr") return fr_nav_language(inputs)
	if (locale === "vi") return vi_nav_language(inputs)
	if (locale === "sw") return sw_nav_language(inputs)
	if (locale === "th") return th_nav_language(inputs)
	if (locale === "bs") return bs_nav_language(inputs)
	if (locale === "ja") return ja_nav_language(inputs)
	if (locale === "ko") return ko_nav_language(inputs)
	if (locale === "pt") return pt_nav_language(inputs)
	if (locale === "it") return it_nav_language(inputs)
	if (locale === "sv") return sv_nav_language(inputs)
	if (locale === "nl") return nl_nav_language(inputs)
	if (locale === "da") return da_nav_language(inputs)
	if (locale === "nb") return nb_nav_language(inputs)
	if (locale === "fi") return fi_nav_language(inputs)
	if (locale === "pl") return pl_nav_language(inputs)
	if (locale === "ru") return ru_nav_language(inputs)
	if (locale === "tr") return tr_nav_language(inputs)
	if (locale === "hi") return hi_nav_language(inputs)
	if (locale === "id") return id_nav_language(inputs)
	if (locale === "ms") return ms_nav_language(inputs)
	if (locale === "cs") return cs_nav_language(inputs)
	if (locale === "el") return el_nav_language(inputs)
	if (locale === "he") return he_nav_language(inputs)
	if (locale === "af") return af_nav_language(inputs)
	if (locale === "hu") return hu_nav_language(inputs)
	return en_nav_language(inputs)
});